import React, { Component } from "react"

import intl from "react-intl-universal"

import ConsoleNav from "../../../components/nav/ConsoleNav"

import "./index.css"
import ContentMain from "../content/Content"
import { consoleInit } from "../../../api/console/index/Init"
import { Layout, Menu } from 'antd'
import CsIcon from "../../../components/iconfont/CsIcon"
import {
    MenuUnfoldOutlined, MenuFoldOutlined
} from '@ant-design/icons'


const { Header, Sider, Content } = Layout

const headerHeight = '48px'
const collapsedWidth = '60px'

// 菜单结构
const MenuGroup1 = [0/*, 15, 16*/]
const MenuGroup2 = [17, 4, 8, 13]
const MenuGroup3 = [7, 10, 11, 12, 18]


class Console extends Component {

    contentMainRef = React.createRef();

    constructor(props) {
        super(props)
        this.state = {
            userInfo: {
                id: '',
                name: '',
                email: '',
            },
            serviceList: [],
            filterSerIdList: [],
            initDone: false,

            //
            siderWidth: '180px',
            collapsed: false,

        }

        this.toggleCollapsed = this.toggleCollapsed.bind(this)
        this.clickSiderMenu = this.clickSiderMenu.bind(this)

    }


    componentWillMount () {
        consoleInit().then((res) => {
            if (res.code === 0) {
                global.serviceInfoMap = res.data.serviceInfoMap
                global.serviceList = res.data.serviceList
                global.pjCateList = res.data.pjCateList
                global.rtmRegionList = res.data.rtmRegionList

                global.auth = {
                    // 所在公司map
                    companyMap: res.data.auth.companyMap,
                    // 所在公司ID list
                    inCompanies: res.data.auth.inCompanies,
                    // 能创建项目的公司ID list
                    canCreatePjCy: res.data.auth.canCreatePjCy,
                    // 用户中心
                    userCenterMenu: res.data.auth.userCenterMenu,
                }
                this.setState({
                    userInfo: res.data.userInfo,
                    serviceList: res.data.serviceList,
                    userMenuList: global.auth.userCenterMenu,
                    filterSerIdList: res.data.filterIdList,
                    initDone: true,
                })
            }
        }, (error) => {
            console.log("consoleInit", error.response.data)
        }
        )
    }


    // 收起/展开导航栏事件
    toggleCollapsed () {
        // console.log('this.state.collapsed true 收起',this.state.collapsed)
        if (this.state.collapsed === false) { // 收起
            this.setState({
                collapsed: true,
                siderWidth: '60px',
            })
        } else {
            this.setState({
                collapsed: false,
                siderWidth: '180px',
            })
        }
    };

    //
    clickSiderMenu (e) {
        let service = e.key
        // rtv/rta服务都属于rtm
        if (service === 15 || service === 16) {
            service = 0
        }
        this.contentMainRef?.current?.changeService?.(service)
        this.contentMainRef?.current?.changeTrendService?.(service)
    }

    render () {
        const { userInfo, filterSerIdList, siderWidth, userMenuList } = this.state
        return (
            this.state.initDone &&
            <div>
                <Layout>
                    <Header style={{
                        padding: '0 0',
                        height: headerHeight,
                        lineHeight: headerHeight,
                        position: 'fixed',
                        top: 0,
                        width: '100%'
                    }}>
                        <ConsoleNav userMenuList={userMenuList}></ConsoleNav>
                    </Header>
                    <Layout hasSider style={{ position: "relative", marginTop: headerHeight }}>
                        <Sider width={siderWidth}
                            collapsible={this.state.collapsed}
                            collapsedWidth={collapsedWidth}
                            style={{
                                overflowY: 'auto',
                                height: '100%',
                                position: 'fixed',
                                left: 0,
                                top: headerHeight,
                                bottom: 0,
                                backgroundColor: '#091E42'
                            }}>


                            <Menu theme="dark" mode="inline" style={{ backgroundColor: '#091E42', paddingBottom: '120px' }}
                                defaultSelectedKeys={['99']} onClick={this.clickSiderMenu}>

                                <Menu.Item key="99" icon={<CsIcon type="line-dashboard" />} style={{ marginTop: '8px' }}>
                                    {intl.get('sys.OVERVIEW')}
                                </Menu.Item>
                                <Menu.Item key="实时互动" disabled={true} style={{ marginTop: '8px' }}>
                                    {this.state.collapsed === false ?
                                        <span>{intl.get('sys.menu_group1')}</span> :
                                        <div className="collapse-title"></div>
                                    }
                                </Menu.Item>

                                {MenuGroup1.map((service) =>
                                    <Menu.Item key={service} title={global.serviceInfoMap[service].label}
                                        icon={<CsIcon type={global.serviceInfoMap[service].icon} />}>
                                        <span>{global.serviceInfoMap[service].label}</span>
                                    </Menu.Item>
                                )}

                                <Menu.Item key="人工智能" disabled={true}>
                                    {this.state.collapsed === false ?
                                        <span>{intl.get('sys.menu_group2')}</span> :
                                        <div className="collapse-title"></div>
                                    }
                                </Menu.Item>
                                {MenuGroup2.map((service) =>
                                    <Menu.Item key={service} title={global.serviceInfoMap[service].label}
                                        icon={<CsIcon type={global.serviceInfoMap[service].icon} />}>
                                        <span>{global.serviceInfoMap[service].label}</span>
                                    </Menu.Item>
                                )}

                                <Menu.Item key="内容安全" disabled={true}>
                                    {this.state.collapsed === false ?
                                        <span>{intl.get('sys.menu_group3')}</span> :
                                        <div className="collapse-title"></div>
                                    }
                                </Menu.Item>
                                {MenuGroup3.map((service) =>
                                    <Menu.Item key={service} title={global.serviceInfoMap[service].label}
                                        icon={<CsIcon type={global.serviceInfoMap[service].icon} />}>
                                        <span>{global.serviceInfoMap[service].label}</span>
                                    </Menu.Item>
                                )}
                            </Menu>

                            <div className="ant-layout-sider-trigger-cus" style={{ width: siderWidth }}>
                                <button className="collapse-btn" onClick={this.toggleCollapsed} style={{ marginBottom: 16 }}>
                                    {React.createElement(this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined)}
                                </button>
                            </div>
                        </Sider>
                        <Content style={{ marginLeft: siderWidth, overflow: 'auto', height: '100vh' }}>
                            <ContentMain ref={this.contentMainRef} userInfo={userInfo} serviceIdList={filterSerIdList}></ContentMain>
                        </Content>
                    </Layout>
                </Layout>


            </div>
        )
    }

}


export default Console

